import { Config } from "../config";

export const UserService = {
    /**
 * [LOGIN]
 * @param {object} data
 * @param {string} data.login
 * @param {string} data.password
 */
    Login(data) {

        var requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.user.login, requestOptions);

    },
    /**
    * [LOGOUT]
    */
    Logout() {
        localStorage.removeItem('user');
    },
    /**
     * [RECOVERPASSWORD]
     * @param {object} data
     * @param {string} data.email
     */
    ResetPassword(data) {

        var requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.user.recoverPassword, requestOptions);

    },
    /**
    * [AUTHENTICATED]
    */
    Authenticated() {

        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader()
        }

        Config.utilities.loadingAuth();

        return fetch(Config.service.user.authenticated, requestOptions)
            .then(response => {

                Config.utilities.loadingAuth();

                if (response.ok) {
                    return true;
                } else {
                    return false;
                }

            }).catch(function () {
                Config.utilities.loadingAuth();
                return false;
            });
    },
    /**
    * [XSRF]
    */
    Xsrf() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.xsrf, requestOptions);

    },
    /**
    * [DASHBOARD]
    */
    Dashboard() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.dashboard, requestOptions);

    },
    /**
    * [TFA]
    */
    GetTFAStatus() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.tfastatus, requestOptions);

    },
    
    Generate2FA() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.tfagenerate, requestOptions);

    },

    WithdrawVerify2FA(formData) {


        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return UserService.Common.Fetch(Config.service.user.withdrawtfaverify, requestOptions);

    },

    Verify2FA(formData) {


        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return UserService.Common.Fetch(Config.service.user.tfaverify, requestOptions);

    },
    
    /**
    * [SETTINGS]
    */
    Settings() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.settings, requestOptions);

    },
    /**
    * [SAVE_SETTINGS]
    */
    SaveSettings(formData) {


        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return UserService.Common.Fetch(Config.service.user.saveSettings, requestOptions);

    },
    /**
    * [PROFILE]
    */
    Profile() {


        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return UserService.Common.Fetch(Config.service.user.profile, requestOptions);

    },
    /**
    * [SAVE_PROFILE]
    */
    SaveProfile(formData) {


        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return UserService.Common.Fetch(Config.service.user.saveProfile, requestOptions);

    },
    /**
 * [USERLIST]
 */
    UserList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }
        return UserService.Common.Fetch(Config.service.common.user.list, requestOptions);

    },

    /**
    * [USERDETAIL]
    */
    Detail(id) {
        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(id)
        }

        return UserService.Common.Fetch(Config.service.common.user.detail, requestOptions);

    },
    /**
   * [USERSAVE]
   */
    Save(data) {
        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.common.user.editsave, requestOptions);

    },
    /**
   * [USERDELETE]
   */
    Delete(id) {
        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(id)
        }

        return UserService.Common.Fetch(Config.service.common.user.delete, requestOptions);

    },
    /**
    * [GET_CURRENCIES]
    */
    GetCurrencyList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }
        return UserService.Common.Fetch(Config.service.common.currency.getList, requestOptions);
    },
    /**
    * [UPDATE_CURRENCY]
    */
    UpdateCurrency(data) {
        var requestOptions = {
            method: 'POST',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.common.currency.update, requestOptions);

    },
    /**
     * [COMMON]
     * @function Fetch
     */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {

                        UserService.Logout();

                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}